const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL;
const environmentBaseUrl = import.meta.env.DEV
  ? "http://localhost:5100/"
  : import.meta.env.VITE_URL;

export const API_BASE_URL = (
  configuredBaseUrl || environmentBaseUrl || "https://ezrabackend.online/"
).replace(/\/?$/, "/");
